class Project {
  constructor({ id, name, description, technologies, imageUrl, link }) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.technologies = technologies; // Array of strings
    this.imageUrl = imageUrl;
    this.link = link;
  }
}

export default Project; 